/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-namespace */
export namespace AppSettings {
	let AppConfig: any = {};

	export const setAppConfig = (config: any) => {
		AppConfig = config;
	};

	export const getAppConfig = () => {
		return AppConfig;
	};
}
